import { globalEnv } from "~/global-env";

const base = (caseId: number) => `${globalEnv.complianceRoute}/case/${caseId}/escalations`;

export const escalationTakeoverPaths = {
  create: (caseId: number, profileId?: number) =>
    `${base(caseId)}/new${profileId ? `?profileId=${profileId}` : ""}`,
  edit: (caseId: number, escalationId: number) => `${base(caseId)}/${escalationId}/edit`,
  view: (caseId: number, escalationId: number) => `${base(caseId)}/${escalationId}`,
};
